function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round",
  strokeWidth: 4,
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#23C386",
  d: "M5.31 19.84L3.5 33.5 11 29l7.5 4.5-1.82-13.68"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 10.5,
  stroke: "#333"
}));

function SvgBootcamps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 38"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNiAzOCI+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIgMikiPgogICAgPHBvbHlsaW5lIHN0cm9rZT0iIzIzQzM4NiIgcG9pbnRzPSI1LjMxIDE5Ljg0IDMuNSAzMy41IDExIDI5IDE4LjUgMzMuNSAxNi42OCAxOS44MiIvPgogICAgPGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iMTAuNSIgc3Ryb2tlPSIjMzMzIi8+CiAgPC9nPgo8L3N2Zz4K";
export { SvgBootcamps as ReactComponent };